import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { UserX } from 'lucide-react';
import PortfolioView from '../features/portfolio/components/PortfolioView';
import TranscriptPrintView from '../features/portfolio/components/TranscriptPrintView';
import EmptyState from '../features/parentPortal/components/EmptyState';

// Renders inside StudentDetailShell's <Outlet />. The shell owns the
// student header + tabs; this component owns the transcript view only.
// The portfolio fetch itself is owned by the shell (started in parallel
// with the student fetch) and handed down via outlet context.
export default function StudentPortfolioSection() {
  const { student, portfolio: portfolioState } = useOutletContext();
  const { data: portfolio, loading, error, unavailable, reload } = portfolioState;

  const firstName = (student?.displayName || '').split(/\s+/)[0] || 'This student';

  // Backend Phase 7: portfolio is real; the 404 branch now only fires in
  // the genuine "you're no longer linked to this student" edge case (e.g.
  // the link was revoked in another tab while this page is open).
  if (unavailable) {
    return (
      <EmptyState
        icon={<UserX size={22} strokeWidth={1.5} />}
        title="You're not linked to this student"
        description="This link may have been revoked. Head back to Family and try again — if you're still supervising them, they'll show up in your list."
      />
    );
  }

  return (
    <>
      <div className="no-print">
        <PortfolioView
          portfolio={portfolio}
          loading={loading}
          error={error}
          onReload={reload}
          subjectFallbackName={`${firstName}'s`}
          onExport={() => window.print()}
          showIdentity={false}
        />
      </div>
      <TranscriptPrintView portfolio={portfolio} studentLabel={student?.displayName} />
    </>
  );
}
